import { computed, makeObservable, observable } from 'mobx';

import { LaboratoryServiceData, Optional } from 'chaika-frontend-types/frontend-cms';
import { LaboratoryStatus } from 'chaika-enums';

import { OptionType } from '@components/Select';
import { makeOptionType } from '@utils/makeOptionTypes';

import { LaboratoryServiceList } from './LaboratoryServiceList';
import { BioCodeList } from './BioCodeList';
import { LaboratoryList } from './LaboratoryList';
import { LaboratoryOrderList } from './LaboratoryOrderList';

export class LaboratoryStore {
    public static Name = 'laboratoryStore' as const;

    @observable public laboratoryServiceList = new LaboratoryServiceList();
    @observable public bioCodeList = new BioCodeList();
    @observable public laboratoryList = new LaboratoryList();
    @observable public laboratoryOrderList = new LaboratoryOrderList();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get bioCodeOptions(): OptionType<string>[] {
        return this.bioCodeList.values.map(({ name, description }) => ({ value: name, label: description }));
    }

    @computed
    public get laboratoryOptions(): OptionType<string>[] {
        return makeOptionType(this.laboratoryList.values);
    }

    @computed
    public get activeLaboratoryOptions(): OptionType<string>[] {
        return makeOptionType(this.laboratoryList.values.filter(lab => lab.status === LaboratoryStatus.Active));
    }

    public getLaboratoryServicesByServiceId(serviceId: string): LaboratoryServiceData[] {
        return this.laboratoryServiceList.getFilteredValues({ serviceId });
    }

    public getBiocodeTitle(laboratoryService: Optional<LaboratoryServiceData>): string {
        return laboratoryService?.loinc
            ? (laboratoryService.specimen?.name ?? '')
            : laboratoryService?.bioCode
              ? (this.bioCodeList.get(laboratoryService.bioCode)?.description ?? laboratoryService.bioCode)
              : '';
    }
}

export const laboratoryStore = new LaboratoryStore();
